import { norsk_gassnett_api } from "@norskgassnett/shared";
import createClient from "openapi-react-query";
import { useStore } from "../../store/store";

// We create and set up the api client here
const apiClient = norsk_gassnett_api.createApiClient({
	baseUrl: import.meta.env.VITE_API_URL,
});
apiClient.use(
	norsk_gassnett_api.authMiddleware({
		getToken: async () => useStore.getState().auth.token ?? undefined,
	}),
);

export const apiHooks = createClient<norsk_gassnett_api.paths>(apiClient);

export type Paths = norsk_gassnett_api.paths;
export type Schemas = norsk_gassnett_api.components["schemas"];
